"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var ResponsiveResizeComponent_1 = require("../base/ResponsiveResizeComponent");
var icon_1 = require("../icon");
var surface_1 = require("../surface");
var itemsList_1 = require("../itemsList");
var react_transition_group_1 = require("react-transition-group");
var Select = /** @class */ (function (_super) {
    tslib_1.__extends(Select, _super);
    function Select(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onWindowScroll = function () {
            if (_this.state.isOpen) {
                _this.setPosition();
            }
        };
        _this.onDocumentClick = function (e) {
            var isOpen = _this.state.isOpen;
            if (_this.isClickOutside(e.target) && isOpen) {
                _this.close(e);
            }
        };
        _this.onClick = function (e) {
            if (utils_1.isMobile || _this.props.disabled || _this.props.readOnly || _this.props.isLoading || (_this.$el && !_this.$el.contains(e.target)) || (_this.$list && _this.$list.contains(e.target))) {
                return;
            }
            var _a = _this.props, onBlur = _a.onBlur, onFocus = _a.onFocus;
            var nextState = {
                isOpen: !_this.state.isOpen
            };
            if (nextState.isOpen) {
                nextState.query = "";
                onFocus && onFocus(e);
                // this.$select.focus();
            }
            else {
                onBlur && onBlur(e);
                // this.$select.blur();
            }
            _this.setState(nextState);
        };
        _this.setExposedRef = function (el) {
            var exposedRef = _this.props.exposedRef;
            _this.$select = el;
            exposedRef && exposedRef(el);
        };
        _this.setListRef = function (el) {
            _this.$list = el;
        };
        _this.setRef = function (el) {
            _this.$el = el;
        };
        _this.onSelectFocus = function (e) {
            var onFocus = _this.props.onFocus;
            onFocus && onFocus(e);
            _this.onClick(e);
        };
        _this.onSelectBlur = function (e) {
            var onBlur = _this.props.onBlur;
            if (!_this.state.isOpen) {
                onBlur && onBlur(e);
            }
        };
        _this.onListItemsChange = function (value) {
            var _a = _this.props, name = _a.name, onChange = _a.onChange, onSelectItem = _a.onSelectItem;
            _this.$select.value = value;
            var event = new Event("change", { bubbles: true });
            _this.$select.dispatchEvent(event);
            if (_this.isUncontrolled) {
                _this.setState({
                    defaultValue: value
                });
            }
            if (onSelectItem) {
                onSelectItem(value, _this.getLabelByValue(value));
            }
            if (_this.state.isOpen) {
                _this.close({});
            }
        };
        _this.onSearch = function (value) {
            _this.setState({
                query: value
            }, function () { return _this.setPosition(); });
            _this.props.onSearch && _this.props.onSearch(value);
        };
        _this.filter = function (item) {
            var query = _this.state.query;
            var itemValue = (_this.getItemValue(item) || "");
            var itemLabel = (_this.getItemLabel(item) || "");
            return utils_1.multiWordFilter(itemLabel, query) || utils_1.multiWordFilter(itemValue, query);
        };
        _this.$el = null;
        _this.$select = null;
        _this.$list = null;
        _this.index = {};
        var state = {
            isOpen: false,
            query: "",
            verticalPositionCssProp: "top",
            horizontalPositionCssProp: "right"
        };
        if (_this.isUncontrolled) {
            state.defaultValue = props.defaultValue;
        }
        _this.state = state;
        _this.initialize();
        return _this;
    }
    Object.defineProperty(Select.prototype, "hasAnyValue", {
        get: function () {
            var value = this.props.value;
            return !!(this.defaultValue || value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "isUncontrolled", {
        get: function () {
            return this.props.defaultValue !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "defaultValue", {
        get: function () {
            return this.state.defaultValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Select.prototype, "showItemsList", {
        get: function () {
            return this.state.isOpen && !utils_1.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    Select.prototype.getMouseEventMap = function () {
        return {
            click: this.onDocumentClick
        };
    };
    Select.prototype.initialize = function () {
        this.indexDataSource(this.props.items);
    };
    Select.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.items !== this.props.items) {
            this.indexDataSource(nextProps.items);
        }
    };
    Select.prototype.indexDataSource = function (dataSource) {
        var _a = this.props, itemLabelKey = _a.itemLabelKey, itemValueKey = _a.itemValueKey;
        if (dataSource.length > 0 && dataSource[0] !== "string") {
            for (var i = 0, len = dataSource.length; i < len; i++) {
                this.index[dataSource[i][itemValueKey]] = dataSource[i][itemLabelKey];
            }
        }
    };
    Select.prototype.componentDidResize = function (e) {
        if (this.state.isOpen) {
            this.setPosition();
        }
    };
    Select.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        utils_1.addEventsToDocument(this.getMouseEventMap());
        window.addEventListener("scroll", this.onWindowScroll, { passive: true });
    };
    Select.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        utils_1.removeEventsFromDocument(this.getMouseEventMap());
        window.removeEventListener("scroll", this.onWindowScroll, { passive: true });
    };
    Select.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.isOpen && !prevState.isOpen) {
            this.setPosition();
        }
    };
    Select.prototype.isClickOutside = function (target) {
        return !this.$el.contains(target) && (!this.$list ? true : !this.$list.contains(target));
    };
    Select.prototype.close = function (withEvent) {
        var onBlur = this.props.onBlur;
        this.setState({
            isOpen: false
        });
        if (withEvent && onBlur) {
            onBlur(withEvent);
        }
    };
    Select.prototype.setPosition = function () {
        var _this = this;
        utils_1.raf(function () {
            var horizontalPositionCssProp = "right", verticalPositionCssProp = "top";
            if (_this.$list) {
                var selectRect = _this.$el.getBoundingClientRect();
                var listRect = _this.$list.getBoundingClientRect();
                if (_this.props.openUp || window.pageYOffset + window.innerHeight < selectRect.top + window.pageYOffset + selectRect.height + listRect.height) {
                    verticalPositionCssProp = "bottom";
                }
                if (selectRect.left + selectRect.width - listRect.width < 0) {
                    horizontalPositionCssProp = "left";
                }
            }
            if (horizontalPositionCssProp !== _this.state.horizontalPositionCssProp ||
                verticalPositionCssProp !== _this.state.verticalPositionCssProp) {
                _this.setState({
                    verticalPositionCssProp: verticalPositionCssProp,
                    horizontalPositionCssProp: horizontalPositionCssProp
                });
            }
        });
    };
    Select.prototype.getItemValue = function (item) {
        var itemValueKey = this.props.itemValueKey;
        return typeof item === "string" ? item : item[itemValueKey];
    };
    Select.prototype.getItem = function () {
        var _this = this;
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue, items = _a.items;
        if ((!value && !defaultValue) || !items) {
            return null;
        }
        return items.find(function (item) { return _this.getItemValue(item) === (value || defaultValue); });
    };
    Select.prototype.getItemLabel = function (item) {
        var _a = this.props, itemLabelKey = _a.itemLabelKey, labelFormatter = _a.labelFormatter;
        var label;
        if (typeof item === "string") {
            label = this.index[item] || item;
        }
        else {
            label = item[itemLabelKey];
        }
        if (labelFormatter) {
            return labelFormatter(item, label);
        }
        return label;
    };
    Select.prototype.getLabelByValue = function (value) {
        var _a = this.props, items = _a.items, itemLabelKey = _a.itemLabelKey, itemValueKey = _a.itemValueKey, selectedLabelFormatter = _a.selectedLabelFormatter;
        for (var i = 0, len = items.length; i < len; i++) {
            if (this.getItemValue(items[i]) === value) {
                return selectedLabelFormatter(this.getItemLabel(items[i]));
            }
        }
        return selectedLabelFormatter(value);
    };
    Select.prototype.renderEmptySearchMessage = function () {
        var theme = this.props.theme;
        return (React.createElement("div", { className: theme["empty-search-message"] },
            React.createElement(icon_1.default, { className: theme["empty-search-message-icon"], iconName: "icon-no-results", size: 4 }),
            React.createElement("div", { className: theme["empty-search-message-text"] },
                React.createElement("span", null, "Oops!"),
                " we couldn't",
                React.createElement("br", null),
                "find any results")));
    };
    Select.prototype.renderListItems = function () {
        var _this = this;
        var _a;
        var _b = this.props, renderUnderList = _b.renderUnderList, children = _b.children, maxItems = _b.maxItems, value = _b.value, defaultValue = _b.defaultValue, theme = _b.theme, items = _b.items, searchable = _b.searchable, innerStyle = _b.innerStyle;
        var _c = this.state, query = _c.query, verticalPositionCssProp = _c.verticalPositionCssProp, horizontalPositionCssProp = _c.horizontalPositionCssProp;
        var wrapperStyles = tslib_1.__assign((_a = {}, _a[verticalPositionCssProp] = "100%", _a[horizontalPositionCssProp] = 0, _a), innerStyle);
        var emptySearchMessage = null;
        var displayItems = items;
        if (searchable && query) {
            displayItems = items.filter(this.filter);
        }
        if (searchable && displayItems.length === 0) {
            emptySearchMessage = this.renderEmptySearchMessage();
        }
        return (React.createElement("div", { className: theme.list, style: wrapperStyles, ref: this.setListRef },
            React.createElement(surface_1.default, { level: 2 },
                React.createElement(itemsList_1.ItemsList, { surfaceLevel: 0, emptySearchMessage: emptySearchMessage, searchable: searchable, query: query, onSearch: this.onSearch, maxItems: maxItems, selected: value || this.defaultValue, onSelectItem: this.onListItemsChange }, displayItems.map(function (item, idx) { return React.createElement(itemsList_1.ListItem, { key: idx, value: _this.getItemValue(item), label: _this.getItemLabel(item) }); })),
                renderUnderList ? renderUnderList : null)));
    };
    Select.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, style = _c.style, theme = _c.theme, className = _c.className, labelFormatter = _c.labelFormatter, onSelectItem = _c.onSelectItem, selectedLabelFormatter = _c.selectedLabelFormatter, children = _c.children, maxItems = _c.maxItems, fill = _c.fill, fillList = _c.fillList, small = _c.small, focus = _c.focus, invalid = _c.invalid, value = _c.value, defaultValue = _c.defaultValue, placeholder = _c.placeholder, loadingPlaceholder = _c.loadingPlaceholder, isLoading = _c.isLoading, exposedRef = _c.exposedRef, items = _c.items, itemLabelKey = _c.itemLabelKey, itemValueKey = _c.itemValueKey, onBlur = _c.onBlur, searchable = _c.searchable, renderUnderList = _c.renderUnderList, blue = _c.blue, orange = _c.orange, purple = _c.purple, red = _c.red, green = _c.green, yellow = _c.yellow, gray = _c.gray, linkFactory = _c.linkFactory, linkIconName = _c.linkIconName, onSearch = _c.onSearch, innerStyle = _c.innerStyle, others = tslib_1.__rest(_c, ["style", "theme", "className", "labelFormatter", "onSelectItem", "selectedLabelFormatter", "children", "maxItems", "fill", "fillList", "small", "focus", "invalid", "value", "defaultValue", "placeholder", "loadingPlaceholder", "isLoading", "exposedRef", "items", "itemLabelKey", "itemValueKey", "onBlur", "searchable", "renderUnderList", "blue", "orange", "purple", "red", "green", "yellow", "gray", "linkFactory", "linkIconName", "onSearch", "innerStyle"]);
        var isOpen = this.state.isOpen;
        var classes = classnames_1.default(theme.select, className, (_a = {},
            _a[theme.mobile] = utils_1.isMobile,
            _a[theme.fill] = fill,
            _a[theme.fillList] = fillList,
            _a[theme.small] = small,
            _a[theme.focus] = focus || isOpen,
            _a[theme.invalid] = invalid,
            _a[theme.open] = isOpen,
            _a[theme.disabled] = this.props.disabled,
            _a[theme.blue] = blue,
            _a[theme.orange] = orange,
            _a[theme.purple] = purple,
            _a[theme.red] = red,
            _a[theme.green] = green,
            _a[theme.yellow] = yellow,
            _a[theme.gray] = gray,
            _a));
        var innerSelectProps = tslib_1.__assign({}, others, { ref: this.setExposedRef, defaultValue: this.defaultValue, onFocus: this.onSelectFocus, onBlur: this.onSelectBlur, value: value });
        if (!utils_1.isMobile) {
            innerSelectProps.onKeyDown = utils_1.pauseEvent;
        }
        var displayPlaceholder = isLoading ? loadingPlaceholder : placeholder;
        var options = (!items || items.length) === 0 && ((this.defaultValue || value) !== undefined) ? [(_b = {},
                _b[itemValueKey] = this.getItemValue((this.defaultValue || value)),
                _b[itemLabelKey] = this.getItemLabel((this.defaultValue || value)),
                _b)] : items;
        var link = (linkFactory && this.getItem()) && linkFactory(this.getItem());
        var handler = null;
        if (link) {
            var LinkComponent = this.context.linkComponent;
            handler = (React.createElement(LinkComponent, tslib_1.__assign({}, link),
                React.createElement("div", { className: theme.link },
                    React.createElement(icon_1.default, { className: theme.linkIcon, iconName: linkIconName || "icon-go-to-link-small", size: 1.4 }))));
        }
        return (React.createElement("div", { className: classes, ref: this.setRef, onClick: this.onClick, style: style },
            React.createElement("div", { className: theme.inner },
                (!this.hasAnyValue || isLoading) ?
                    (React.createElement("div", { className: theme.placeholder }, displayPlaceholder || "\u00A0")) :
                    (React.createElement("div", { className: theme.value },
                        handler,
                        this.getLabelByValue(value || this.defaultValue))),
                React.createElement(icon_1.default, { className: theme.icon, size: 1, iconName: "icon-arrow-down-small" })),
            React.createElement(react_transition_group_1.CSSTransition, { unmountOnExit: true, in: this.showItemsList, classNames: {
                    enter: theme.listEnter,
                    enterActive: theme.listEnterActive,
                    exit: theme.listLeave,
                    exitActive: theme.listLeaveActive
                }, timeout: 200 }, this.renderListItems()),
            React.createElement("select", tslib_1.__assign({}, innerSelectProps),
                React.createElement("option", null),
                options.map(function (item, idx) { return React.createElement("option", { key: idx, value: _this.getItemValue(item) }, _this.getItemLabel(item)); }))));
    };
    Select.defaultProps = {
        disabled: false,
        required: false,
        readOnly: false,
        fill: false,
        placeholder: "Select Option",
        onChange: utils_1.noop,
        itemValueKey: "value",
        itemLabelKey: "label",
        loadingPlaceholder: "Loading...",
        selectedLabelFormatter: utils_1.echo,
        innerStyle: {}
    };
    Select.contextTypes = {
        linkComponent: PropTypes.any
    };
    return Select;
}(ResponsiveResizeComponent_1.default));
exports.default = Select;
